import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

const creatorsImg = require('images/admin/campaign_wrap_up/icons/icon-creators.png');
const statesImg = require('images/admin/campaign_wrap_up/icons/icon-states.png');

function CreatorsStatesAnalytics(props) {
    const {creatorCount, statesCount, borders, renderForPdf, getAssetPath} = props;
    const creatorsStatesAnalyticsClasses = classNames('creators-states-analytics', {
        'container-border-top': borders.top,
        'container-border-right': borders.right,
        'container-border-bottom': borders.bottom,
        'container-border-left': borders.left
    });
    const statesUniqueCount = R.length(R.keys(statesCount));

    return (
        <div className={creatorsStatesAnalyticsClasses}>
            <div className="creator-count">
                <img src={getAssetPath(creatorsImg)} />
                <div className="count">{creatorCount}</div>
                <div className="count-text creator-text">CREATORS</div>
            </div>
            <div className="states-count">
                <img src={getAssetPath(statesImg)} />
                <div className="count">{statesUniqueCount}</div>
                <div className="count-text states-text">STATES</div>
            </div>

            {/*STYLES*/}

            <style>{`
        .creators-states-analytics {
        width: 50%;
        }

        .creator-count {
        padding: 0px 50px;
        }

        .states-count {
        position: relative;
        padding: 0px 50px;
        }

        .count {
        font-size: 65px;
        font-weight: bold;
        color: #4ed2c3;
        }

        .count-text {
        font-size: 20px;
        font-weight: bold;
        }

        .states-text {
        position: relative;
        bottom: 1px;
        }

        .container-border-top {
        border-top: 1px solid #d4d4d4;
        }

        .container-border-right {
        border-right: 1px solid #d4d4d4;
        }

        .container-border-bottom {
        border-bottom: 1px solid #d4d4d4;
        }

        .container-border-left {
        border-left: 1px solid #d4d4d4;
        }
        `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
        .creators-states-analytics {
        display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            }

            .creator-count {
            display: flex;
            flex-direction: column;
            align-items: center;
            }

            .states-count {
            display: flex;
            flex-direction: column;
            align-items: center;
            }
            `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
            .creators-states-analytics {
            display: inline-block;
                vertical-align: top;
                }

                .creator-count {
                display: inline-block;
                vertical-align: top;
                }

                .states-count {
                display: inline-block;
                vertical-align: top;
                }
                `}</style>
            ) : null}
        </div>
    );
}

CreatorsStatesAnalytics.propTypes = {};

export default CreatorsStatesAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/creators_states_analytics.js